export const ROOT_FOLDER_NAME = 'Files';
